import { createApp } from "vue";
import App from "./App.vue";
import ElementPlus from "element-plus";
import router from "./router";
import auth, { authHeader } from "./plugins/auth";
import { mixinConfig } from "@/mixins";
import { store } from "./store";
import { emitter } from "./plugins/event-bus";
import ru from "element-plus/es/locale/lang/ru";
import "@/plugins/font-awesome";
import "./styles/index.scss";
import "dayjs/locale/ru";
import mixins from "@/mixins";
import { encryptHelper } from "./helpers/encrypt-helper";
import "./exclusiveAssign";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Vue3EasyDataTable
import Vue3EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";

// update DevExtreme locale
import { locale, loadMessages } from "devextreme/localization";
import * as ruMessages from "devextreme/localization/messages/ru.json";
loadMessages(ruMessages);
locale("ru");

import axios from "axios";

const axiosGlobal = axios.create({
  baseURL: mixins.getBaseUrl(),
  headers: Object.assign(authHeader, {
    // uid: `${$auth.state.data?.id}`,
    uid: `noname`,
  }),
});

axiosGlobal.interceptors.request.use((request) => {
  auth.check() && request.headers.setAuthorization(`Bearer ${auth.token()}`);
  // if (request.data) {
  //   encryptHelper.getEncryptedValueFromMapping(request.data);
  // }
  // if (request.url) {
  //   request.url = encryptHelper.getEncryptedStringFromMapping(request.url);
  // }
  return request;
});

axiosGlobal.interceptors.response.use((response) => {
  // if (response.data) {
  //   encryptHelper.addValueToEncryptedMapping(response.data);
  // }
  return response;
});

export default axiosGlobal;

import errorLogHelper from "./helpers/error-log-helper";

const app = createApp(App);

app.config.globalProperties.$emitter = emitter;
app.mixin(mixinConfig);
app.use(ElementPlus, {
  locale: ru,
});
app.component("font-awesome-icon", FontAwesomeIcon);
app.component("EasyDataTable", Vue3EasyDataTable);
app.use(store);
app.use(router);
app.use(auth);

errorLogHelper.init({ axios: axiosGlobal, vue: app, auth: auth });

app.mount("#app");
